import { DistancePipe, WeightPipe } from '@agilox/common';
import { PlausibleDirective } from '@agilox/directive/plausible';
import { CustomNumberPipe } from '@agilox/pipe/custom-number';
import { EmptyPipe } from '@agilox/pipe/empty';
import { SecondsPipe } from '@agilox/pipe/seconds';
import {
	ButtonComponent,
	DropdownModule,
	EmptyStateComponent,
	HeadlineComponent,
	IconModule,
	SelectModule,
	SpinnerComponent,
	TagComponent,
	TooltipModule,
} from '@agilox/ui';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgChartsModule } from 'ng2-charts';
import { MaterialModule } from '../material/material.module';
import { AnalyticsSpinnerComponent } from '../shared/components/spinner/analytics-spinner.component';
import { FailureCategorySelectOptionsPipe } from '../shared/pipes/failure-category-select-options.pipe';
import { FailuresHeatmapCategoryFilterPipe } from '../shared/pipes/failures-heatmap-category-filter.pipe';

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		TranslateModule,
		MaterialModule,
		NgChartsModule,
		SelectModule,
		CustomNumberPipe,
		DropdownModule,
		FailuresHeatmapCategoryFilterPipe,
		WeightPipe,
		DistancePipe,
		AnalyticsSpinnerComponent,
		SpinnerComponent,
		EmptyStateComponent,
		HeadlineComponent,
		IconModule,
		ButtonComponent,
		TooltipModule,
		EmptyPipe,
		SecondsPipe,
		PlausibleDirective,
		FailureCategorySelectOptionsPipe,
		FormsModule,
		TagComponent,
	],
	exports: [NgChartsModule],
})
export class WidgetsModule {}
